import { render } from "./UsersGamerListPage.vue?vue&type=template&id=284ca6de&ts=true"
import script from "./UsersGamerListPage.vue?vue&type=script&lang=ts"
export * from "./UsersGamerListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__